<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Queue Name: {{ queueName }}</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content>
  @if(ObjectHash.length === 0){
  <div class="no_data_display">
    {{ "No Data To Display" }}
  </div>
  }
  @if(ObjectHash.length != 0){
<fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='ObjectHash' [pageSize]="15"></fn-table>
  }
</mat-dialog-content>
